var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0efef;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #f6ef78;\n      }\n\n      .cls-3 {\n        fill: #ec7d64;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    className: "cls-1",
    cx: 79,
    cy: 154,
    rx: 74,
    ry: 73
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    className: "cls-3",
    cx: 58,
    cy: 28.5,
    rx: 29,
    ry: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    className: "cls-2",
    cx: 12,
    cy: 69,
    r: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCircles);
export default __webpack_public_path__ + "static/media/video-circles.8212bef40234acc5456723a2e7d3d5a1.svg";
export { ForwardRef as ReactComponent };